import React, { useEffect } from "react";
import { Routes, Route, useLocation } from "react-router-dom";
import { logPageView } from "../../analytics";

import Profile from "../UserSettings/Profile";
import Settings from "../UserSettings/Settings";
import Notifications from "../UserSettings/Notifications";
import MainProjects from "../Projects/MainProjects";
import NewProject from "../Projects/NewProject";
import SupportMain from "../Support/SupportMain";
import NewSupport from "../Support/NewSupport";
import OpenTicket from "../Support/OpenTicket";
import MainBilling from "../Billing/MainBilling";
import MainApi from "../API/MainApi";
import InitialSetupItem from "../../Components/InitialSetupItem";
import Invoice from "../Billing/invoice";

function MainView({ userData }) {
  const location = useLocation();

  useEffect(() => {
    logPageView(location.pathname + location.search);
  }, [location]);

  return (
    <div className="main_view_container">
      <InitialSetupItem/>
      <Routes>
        <Route path="profile" element={<Profile userData={userData} />} />
        <Route path="settings" element={<Settings userData={userData} />} />
        <Route path="notifications" element={<Notifications userData={userData} />} />

        {/* Admin center */}
        <Route path="projects" element={<MainProjects userData={userData} />} />
        <Route path="projects/new_project" element={<NewProject userData={userData} />} />
        <Route path="api" element={<MainApi userData={userData} />} />

        {/* Support */}
        <Route path="support" element={<SupportMain userData={userData} />} />
        <Route path="support/new-ticket" element={<NewSupport userData={userData} />} />
        <Route path="support/:ticket_id" element={<OpenTicket userData={userData} />} />

        {/* Billing */}
        <Route path="billing" element={<MainBilling userData={userData} />} />

      </Routes>
    </div>
  );
}

export default MainView;
